import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiErrorCallback} from './useHandleApiErrorCallback';

export function usePostApiCallback<T = any>() {
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<T>();
   const handleError = useHandleApiErrorCallback();
   const request = React.useCallback(
      (
         url: string,
         options?: {
            onSuccess?: (data: T) => void;
            onFailure?: (error: any) => void;
            body?: BodyInit | null;
            searchParams?: Record<string, string>;
         }
      ) => {
         let _url = url;

         if (options?.searchParams) {
            _url = `${_url}?${new URLSearchParams(options?.searchParams)}`;
         }
         setLoading(true);
         setState(undefined);
         ApiService.postSecureJson(_url, options?.body || '')
            .then((res) => {
               return res.json().catch(() => res);
            })
            .then((data: T) => {
               setState(data);
               setLoading(false);
               options?.onSuccess?.(data);
            })
            .catch(handleError({url, setError, setLoading, onFailure: options?.onFailure}));
      },
      [handleError, setError, setLoading, setState]
   );
   return {request, state, loading, error};
}
